export const hackwatchMessages = {
  en: {
    hackwatch: {
      // ── Posts Table ──────────────────────────────────────────────────────
      posts: {
        title: 'Hack Posts',
        filtersTitle: 'Filters',
        filterReset: 'Reset filters',
        filterCountryLabel: 'Country',
        filterCountryPlaceholder: 'All countries…',
        filterCountriesSelected: '{0} Countries',
        filterIndustryLabel: 'Industry',
        filterIndustryPlaceholder: 'All industries…',
        filterIndustriesSelected: '{0} Industries',
        filterGroupLabel: 'Hacker Group',
        filterGroupPlaceholder: 'All groups',
        filterDateLabel: 'Date Range',
        filterDatePlaceholder: 'Start – End',
        filterSearchPlaceholder: 'Search…',
        filtersActive: '{0} filter(s) active',
        colTitle: 'Title',
        colGroup: 'Group',
        colCountry: 'Country',
        colDomain: 'Domain',
        colIndustry: 'Industry',
        colAttackDate: 'Attack',
        colDiscovered: 'Discovered',
        untitled: 'Untitled',
        loadFailed: 'Posts could not be loaded.',
        // stats panel
        statsDays7:            'Last 7 days',
        statsDays30:           'Last 30 days',
        statsDays90:           'Last 90 days',
        statsDays365:          'Last year',
        statsGroups:           'Top Groups',
        statsCountries:        'Top Countries',
        statsIndustries:       'Top Industries',
        statsRecent:           'Recently Discovered',
        statsOther:            'Other',
        statsUnknown:          'Unknown',
        statsLoadFailed:       'Stats could not be loaded.',
        chipGroup:             'Group',
        chipCountry:           'Country',
        chipIndustry:          'Industry',
      },

      // ── Post Details ──────────────────────────────────────────────────────
      postDetail: {
        pageTitle: 'Hackwatch – Post {id}',
        editBtn: 'Edit',
        doneBtn: 'Done',
        backBtn: 'Back',
        noTitle: 'No Title',
        unknownGroup: 'Unknown Group',
        discovered: 'Discovered',
        created: 'Created',
        updated: 'Updated',
        domain: 'Domain',
        attack: 'Attack',
        publicPage: 'Public Page',
        claimLeak: 'Claim/Leak',
        extraInfos: 'Additional Info',
        screenshot: 'Screenshot',
        noScreenshot: 'No screenshot available.',
        companyData: 'Company Data',
        companyName: 'Company',
        address: 'Address',
        register: 'Register',
        vatId: 'VAT ID',
        management: 'Management',
        contact: 'Contact',
        industry: 'Industry',
        websiteLang: 'Website Language',
        whois: 'WHOIS',
        openCorporates: 'OpenCorporates',
        viewEntry: 'View Entry',
        impressum: 'Imprint',
        lastEnriched: 'Last Enriched',
        editDetails: 'Edit Details',
        fieldSelectPlaceholder: 'Select field…',
        valuePlaceholder: 'Enter value…',
        addBtn: 'Add',
        allDetails: 'All Details',
        noDetails: 'No details available.',
        settingName: 'Setting',
        value: 'Value',
        captured: 'Captured',
        loadFailed: 'Loading failed.',
        settingsLoadFailed: 'Settings could not be loaded.',
        saved: 'Saved',
        added: 'Added',
        deleted: 'Deleted',
        saveFailed: 'Save failed.',
        addFailed: 'Add failed.',
        deleteFailed: 'Delete failed.',
        confirmDelete: 'Really delete "{name}"?',
        detailUpdated: '{name} updated.',
        detailRemoved: '{name} removed.',
        detailSaved: '{name} saved.',
        released: 'Released',
        releaseFailed: 'Release failed.',
        detailReleased: '{name} released for automatic updates.',
        manualLockHint: 'Manually edited — protected from automatic overwrites by the updater.',
        releaseHint: 'Release for automatic updates (the updater may overwrite this value again).',
        foundedPrefix: 'Est.',
        infostealer: 'Infostealer Intelligence',
        isEmployees: 'Compromised Employees',
        isUsers: 'Compromised Users',
        isThirdParties: 'Third Parties',
        isEmployeesUrl: 'Employee URLs',
        isUsersUrl: 'User URLs',
        isLastEmployee: 'Last Employee Compromised',
        isLastUser: 'Last User Compromised',
        isStealers: 'Detected Stealers',
        isUpdated: 'Data as of',
      },

      // ── Groups Table ──────────────────────────────────────────────────────
      groups: {
        title: 'Hacker Groups',
        addBtn: 'Add Group',
        editTooltip: 'Edit',
        deleteTooltip: 'Delete',
        colId: 'ID',
        colName: 'Name',
        colDescription: 'Description',
        colCreated: 'Created',
        colUpdated: 'Last Update',
        colVictims: 'Victims',
        colCountry: 'Country',
        colTtps: 'TTPs',
        colTools: 'Tools',
        colFirstSeen: 'First seen',
        colStateSponsor: 'State Sponsor',
        filterRaasLabel: 'RaaS',
        filterRaasAll: 'All',
        filterRaasOnly: 'RaaS only',
        filterRaasNone: 'No RaaS',
        badgeRaas: 'RaaS',
        filterCountryLabel: 'Country',
        filterCountryPlaceholder: 'All countries',
        filterCountrySearch: 'Search country…',
        filterStateSponsorLabel: 'State sponsor',
        filterStateSponsorPlaceholder: 'All sponsors',
        filterStateSponsorAny: 'Any state-sponsored',
        filterStateSponsorNone: 'Without state sponsor',
        filterHasTtps: 'Linked TTPs',
        filterHasTools: 'Linked Tools',
        filterHasTtpsYes: 'With TTPs',
        filterHasTtpsNo: 'Without TTPs',
        filterHasToolsYes: 'With Tools',
        filterHasToolsNo: 'Without Tools',
        filterAny: 'Any',
        filterReset: 'Reset filters',
        filtersTitle: 'Filters',
        sortByLabel: 'Sort by',
        dialogCreate: 'Add Group',
        dialogEdit: 'Edit Group',
        formName: 'Name',
        formNamePlaceholder: 'e.g. LockBit',
        formDescription: 'Description',
        formDescriptionPlaceholder: 'Short description (optional)',
        nameMissing: 'Please enter a name.',
        saved: 'Saved',
        groupCreated: 'Group created.',
        groupUpdated: 'Group updated.',
        deleted: 'Deleted',
        groupDeleted: 'Group removed.',
        saveFailed: 'Save failed.',
        deleteFailed: 'Delete failed.',
        loadFailed: 'Groups could not be loaded.',
        confirmDelete: 'Really delete group "{name}"?',
        statsActivity: 'Activity',
        statsActive: 'Active',
        statsInactive: 'Inactive',
        statsRecent: 'Recently Added',
        statsCountries: 'Countries',
        statsTtps: 'Top TTPs',
        statsTools: 'Top Tools',
        statsYears: 'First Seen by Year',
        statsOther: 'Other',
        statsUnknown: 'Unknown',
        statsLoadFailed: 'Failed to load group statistics.',
        statsDays7: '7 days',
        statsDays30: '30 days',
        statsDays90: '90 days',
        statsDays365: '1 year',
        chipActivity: 'Activity',
        chipTtp: 'TTP',
        chipTool: 'Tool',
        chipFirstSeen: 'First Seen',
      },

      // ── Group Detail Overview ─────────────────────────────────────────────
      groupDetail: {
        pageTitle: 'Hacker Group – Details',
        legendOverview: 'Hacker Group',
        legendKpis: 'Summary / KPIs',
        legendAliases: 'Aliases / Known Names',
        legendProfiles: 'Intelligence Sources',
        legendLocations: 'Locations / Onion Sites',
        legendTtps: 'MITRE ATT&CK TTPs',
        legendPosts: 'Hack Posts',
        legendTools: 'Tools',
        legendCoverage: 'SIEM Workflow Coverage',
        labelName: 'Name',
        labelDescription: 'Description',
        labelCountry: 'Country',
        labelStateSponsor: 'State Sponsor',
        labelAttributionConfidence: 'Attribution',
        labelRaas: 'RaaS',
        labelVictimCount: 'Victims',
        labelFirstSeen: 'First seen',
        labelUrl: 'URL',
        labelMotive: 'Motive',
        labelTargetedSectors: 'Targeted Sectors',
        labelFamilies: 'Malware Families',
        labelMitreGroup: 'MITRE ATT&CK',
        labelMalpedia: 'Malpedia',
        labelCreated: 'Created',
        labelUpdated: 'Updated',
        overviewLoading: 'Loading group details…',
        overviewNotFound: 'No group details found.',
        overviewError: 'An error occurred while loading group details.',
        kpisLoading: 'Loading KPIs…',
        kpisError: 'Summary could not be loaded.',
        profilesLoading: 'Loading sources…',
        profilesEmpty: 'No intelligence sources available.',
        profilesError: 'An error occurred while loading intelligence sources.',
        profileColUrl: 'URL',
        profileColAdded: 'Added',
        profileAdd: 'Add Source',
        profileAddDialogTitle: 'New Intelligence Source',
        profileUrlLabel: 'URL',
        profileUrlPlaceholder: 'https://…',
        profileAdded: 'Source added.',
        profileAddFailed: 'Failed to add source.',
        profileDeleted: 'Source removed.',
        profileDeleteFailed: 'Failed to delete source.',
        profileDeleteConfirm: 'Remove this intelligence source?',
        profileDuplicate: 'This URL is already stored for this group.',
        locationsEmpty: 'No locations available.',
        locationsError: 'Locations could not be loaded.',
        locColStatus: 'Status',
        locColUrl: 'URL',
        locColTitle: 'Title',
        locColLastScrape: 'Last Scrape',
        locStatusOnline: 'Online',
        locStatusOffline: 'Offline',
        locStatusUnknown: 'Not yet scraped',
        locShowOffline: 'Show offline ({count})',
        locHideOffline: 'Hide offline',
        locAdd: 'Add Location',
        locAddDialogTitle: 'New Location',
        locFqdnLabel: 'URL / Domain',
        locFqdnPlaceholder: 'http://…onion or https://…',
        locTitleLabel: 'Title (optional)',
        locTitlePlaceholder: 'Short description…',
        locAdded: 'Location added.',
        locAddFailed: 'Failed to add location.',
        locDeleted: 'Location removed.',
        locDeleteFailed: 'Failed to delete location.',
        locDeleteConfirm: 'Remove this location?',
        locDuplicate: 'This URL is already stored for this group.',
        addAlias: 'Add',
        newAliasPlaceholder: 'New alias…',
        aliasName: 'Alias',
        aliasTime: 'Timestamp',
        noAliases: 'No aliases.',
        aliasLoadFailed: 'Aliases could not be loaded.',
        offlineLocations: 'Offline ({count})',
        noWorkflowLinked: 'No Workflow',
        coveredOnly: 'Covered TTPs only',
        allTtps: 'All TTPs',
        covered: 'covered',
        gaps: 'gaps',
        workflows: 'Workflows',
        noTtps: 'No TTPs found.',
        noPosts: 'No Posts.',
      },

      // ── TTP Table ─────────────────────────────────────────────────────────
      ttps: {
        title: 'TTPs',
        tabMatrix: 'Matrix',
        tabTactics: 'Tactics',
        tabTechniques: 'Techniques',
        matrixHint: 'Click on a technique to open its detail page.',
        matrixOther: 'Other / Uncategorised',
        matrixSelectTactic: 'Select a tactic on the left to show its techniques.',
        tacticTechniques: 'Techniques',
        filtersTitle: 'Filters',
        filterReset: 'Reset filters',
        tacticLabel: 'Tactic',
        tacticPlaceholder: 'All tactics',
        allTactics: 'All Tactics',
        detectionsLabel: 'Detections',
        detectionsAll: 'All',
        detectionsYes: 'With detections',
        detectionsNone: 'Without detections',
        onlyWithDetections: 'With detections only',
        colTechnique: 'Technique',
        colTactic: 'Tactic',
        colDescription: 'Description',
        colUpdated: 'Updated',
        colMitre: 'MITRE',
        colConfidence: 'Confidence',
        colLinkedAt: 'Linked at',
        viewDetails: 'Details',
        noTtps: 'No TTPs available.',
        loadFailed: 'TTPs could not be loaded.',
      },

      // ── MITRE ATT&CK Coverage (redesign /threat-intel/mitre) ──────────────
      mitre: {
        title: 'MITRE ATT&CK',
        subtitle: 'Detection coverage across the ATT&CK matrix',
        modeMatrix: 'Matrix',
        modeCards: 'Cards',
        kpiTechniques: 'Techniques',
        kpiCovered: 'Covered',
        kpiGaps: 'Gaps',
        kpiCoverage: 'Coverage',
        coverageLegend: 'Coverage',
        legendGap: 'No coverage',
        legendLow: 'Low',
        legendMed: 'Medium',
        legendHigh: 'High',
        tacticsLabel: 'Tactics',
        allTactics: 'All tactics',
        techniquesCount: 'techniques',
        noTechniques: 'No techniques in this tactic.',
        statGroups: 'Groups',
        statGroupsTip: 'Threat groups using this technique (CTI)',
        statWorkflows: 'Workflows',
        statWorkflowsTip: 'SIEM workflows covering this technique (visible to you)',
        gapBadge: 'Gap',
        coveredBadge: 'Covered',
        selectHint: 'Select a technique to see its details, coverage and recent platform events.',
        detailDescription: 'Description',
        detailTactics: 'Tactics',
        detailGroups: 'Threat groups using this technique',
        detailWorkflows: 'Workflows covering this technique',
        detailEvents: 'Recent platform events',
        eventsHeuristicHint: 'Heuristic match via workflow name — partner customers only.',
        noGroups: 'No threat groups linked.',
        noWorkflows: 'No covering workflows visible to you.',
        noEvents: 'No matching platform events.',
        noDescription: 'No description available.',
        subtechnique: 'Sub-technique',
        colGroup: 'Group',
        colConfidence: 'Confidence',
        colSource: 'Source',
        colWorkflow: 'Workflow',
        colSeverity: 'Severity',
        colCustomer: 'Customer',
        colEvent: 'Event',
        colWhen: 'When',
        loadFailed: 'MITRE matrix could not be loaded.',
        closeDetail: 'Close',
        openLegacy: 'Open full page',
      },

      // ── TTP Detail ────────────────────────────────────────────────────────
      ttpDetail: {
        backBtn: 'Back',
        legendDescription: 'Description',
        legendDetections: 'Detections',
        legendMitigations: 'Mitigations',
        legendMeta: 'Meta',
        legendReferences: 'References',
        legendGroups: 'Hacker Groups using this TTP',
        legendWorkflows: 'SIEM Workflows covering this TTP',
        noMitreId: 'No MITRE ID set — workflow matching not possible.',
        noGroupsLinked: 'No groups linked.',
        noWorkflows: 'No SIEM workflows found covering this technique.',
        createdAt: 'Created',
        updatedAt: 'Updated',
        version: 'Version',
        colGroup: 'Group',
        colWorkflow: 'Workflow',
        colSeverity: 'Severity',
        colConfidence: 'Confidence',
        colRationale: 'Rationale',
        colSource: 'Source',
        colLinkedAt: 'Linked',
        loadFailed: 'Loading failed.',
      },

      // ── Tools ─────────────────────────────────────────────────────────────
      tools: {
        title: 'Tools (Ranked)',
        colRank: 'Rank',
        colTool: 'Tool',
        colCategory: 'Category',
        colLinks: 'Links',
        colLastLink: 'Last Link',
        categoryPlaceholder: 'Category',
        noTools: 'No tools available.',
        loadFailed: 'Tools could not be loaded.',
      },

      // ── Extension ────────────────────────────────────────────────────────
      extension: {
        title: 'Extensions',
        colId: 'ID',
        colExtension: 'Extension',
        colGroup: 'Hacker Group',
        addBtn: 'Add Extension',
        editTooltip: 'Edit',
        deleteTooltip: 'Delete',
        dialogCreate: 'Add Extension',
        dialogEdit: 'Edit Extension',
        formExtension: 'Extension',
        formGroup: 'Hacker Group',
        formGroupPlaceholder: 'Please select',
        nameMissing: 'Please enter an extension name.',
        groupMissing: 'Please select a hacker group.',
        groupsLoadFailed: 'Hacker groups could not be loaded.',
        loadFailed: 'Extensions could not be loaded.',
        saved: 'Saved',
        extensionCreated: 'Extension created.',
        extensionUpdated: 'Extension updated.',
        deleted: 'Deleted',
        extensionDeleted: 'Extension removed.',
        saveFailed: 'Save failed.',
        deleteFailed: 'Delete failed.',
        invalidId: 'No valid ID found.',
        confirmDelete: 'Really delete this extension?',
      },

      // ── Posts by Group ────────────────────────────────────────────────────
      postsByGroup: {
        title: 'Hack Posts',
        colTitle: 'Title',
        colCountry: 'Country',
        colDomain: 'Domain',
        colDiscovered: 'Discovered',
        noPosts: 'No posts available.',
        loadFailed: 'Posts could not be loaded.',
      },

      // ── Groups Overview ───────────────────────────────────────────────────
      groupsOverview: {
        colGroup: 'Group',
        colMembers: 'Members',
        colLocations: 'Locations',
        colProfiles: 'Profiles',
        colToolsLinks: 'Tools Links',
        colTtpLinks: 'TTP Links',
        loadFailed: 'Overview could not be loaded.',
      },

      // ── Group History ────────────────────────────────────────────────────
      groupHistory: {
        title: 'Hacker Group History',
        loading: 'Loading history…',
        error: 'An error occurred while loading history.',
        currentName: 'Current Name',
        recentChanges: 'Recent Name Changes',
        changedAt: 'At {date}, changed to {name}',
        noHistory: 'No history available.',
      },

      // ── IOCs ─────────────────────────────────────────────────────────────
      iocs: {
        pageTitle: 'IOCs – Indicators of Compromise',
        legendTitle: 'IOCs',
        filtersTitle: 'Filters',
        filterReset: 'Reset filters',
        filterTypeLabel: 'Type',
        filterTypeAll: 'All Types',
        filterGroupLabel: 'Hacker Group',
        filterGroupPlaceholder: 'All groups',
        filterDateLabel: 'Created (Date Range)',
        filterDatePlaceholder: 'Start – End',
        addBtn: 'Add IOC',
        deleteAllBtn: 'Delete all IOCs',
        confirmDeleteAll: 'Really delete ALL IOCs for this group?',
        colType: 'Type',
        colValue: 'Value',
        colNote: 'Note',
        colCreated: 'Created',
        colGroup: 'Group',
        filterTypePlaceholder: 'IOC Type',
        dialogCreate: 'Add IOC',
        dialogEdit: 'Edit IOC',
        formType: 'Type',
        formTypePlaceholder: 'e.g. ip, domain, md5',
        formValue: 'Value',
        formValuePlaceholder: 'IOC value',
        formSource: 'Source',
        formNote: 'Note (optional)',
        typeMissing: 'Please enter a type.',
        valueMissing: 'Please enter a value.',
        saved: 'Saved',
        iocCreated: 'IOC added.',
        iocUpdated: 'IOC updated.',
        deleted: 'Deleted',
        iocDeleted: 'IOC removed.',
        allDeleted: 'All IOCs removed.',
        saveFailed: 'Save failed.',
        deleteFailed: 'Delete failed.',
        loadFailed: 'IOCs could not be loaded.',
        noIOCs: 'No IOCs available.',
        typeSummary: 'Type Summary',
        editTooltip: 'Edit',
        deleteTooltip: 'Delete',
        detailTitle: 'IOC Details',
        detailSource: 'Source',
        colThreatType: 'Threat Type',
        colConfidence: 'Confidence',
        colReporter: 'Reporter',
        colFirstSeen: 'First Seen',
        colTags: 'Tags',
        filterSource: 'Source',
        filterSourceAll: 'All Sources',
        filterSourcePlaceholder: 'Source',
        filterThreatTypeLabel: 'Threat Type',
        filterThreatTypePlaceholder: 'All threat types',
        filterConfidenceLabel: 'Confidence',
        filterConfidencePlaceholder: 'All levels',
        confidenceHigh: 'High (≥75%)',
        confidenceMedium: 'Medium (40–74%)',
        confidenceLow: 'Low (<40%)',
        // stats panel
        statsGroups:      'Top Groups',
        statsTypes:       'IOC Types',
        statsThreatTypes: 'Threat Types',
        statsConfidence:  'Confidence',
        statsOther:       'Other',
        statsLoadFailed:  'Stats could not be loaded.',
      },
      victims: {
        title: 'Affected Companies',
        subtitle: 'Companies linked to ransomware leak posts.',
        filtersTitle: 'Filters',
        filterReset: 'Reset',
        search: 'Search company or domain',
        filterCountryLabel: 'Country',
        filterCountryPlaceholder: 'All countries…',
        filterCountriesSelected: '{0} countries',
        filterIndustryLabel: 'Industry',
        filterIndustryPlaceholder: 'All industries…',
        filterIndustriesSelected: '{0} industries',
        filterGroupLabel: 'Group',
        filterGroupPlaceholder: 'All groups…',
        repeatOnly: 'Repeat only (>1 post)',
        multiGroupOnly: 'Multiple groups only',
        resolve: 'Re-run matching',
        resolveHint: 'Reassign posts to companies (also runs each updater cycle).',
        colCompany: 'Company',
        colDomain: 'Domain',
        colCountry: 'Country',
        colIndustry: 'Industry',
        colCount: 'Posts',
        colGroups: 'Groups',
        colFirst: 'First hit',
        colLast: 'Last hit',
        manual: 'Curated',
        manualHint: 'Has manually curated fields.',
        noVictims: 'No companies found.',
        loadFailed: 'Affected companies could not be loaded.',
        detailTitle: 'Company details',
        pageTitle: 'Affected company',
        overviewTitle: 'Master data',
        profileTitle: 'Company profile',
        profileEmpty: 'No company data yet — it fills in automatically as posts are enriched.',
        fieldEmployees: 'Employees',
        fieldFounded: 'Founded',
        fieldLegalForm: 'Legal form',
        fieldCity: 'City',
        fieldAddress: 'Address',
        sourceManual: 'Manual',
        sourceManualHint: 'Manually set — protected from automatic updates.',
        sourceAuto: 'From posts',
        sourceAutoHint: 'Filled automatically from linked posts.',
        postsTitle: 'Linked hack posts',
        noPosts: 'No posts linked.',
        colPostTitle: 'Post title',
        colGroup: 'Group',
        colDiscovered: 'Discovered',
        colActions: 'Actions',
        openPost: 'Open post',
        locked: 'Pinned',
        lockedHint: 'Manually pinned to this company.',
        edit: 'Edit',
        editTitle: 'Edit company',
        fieldName: 'Display name',
        fieldDomain: 'Primary domain',
        fieldCountry: 'Country',
        fieldIndustry: 'Line of business',
        fieldNotes: 'Notes',
        merge: 'Merge company',
        mergeTitle: 'Merge another company into this one',
        mergePlaceholder: 'Search company to merge in…',
        mergeHint: 'The selected company’s posts move here; it becomes an alias.',
        split: 'Split off',
        splitTitle: 'Split post into a new company',
        splitNewName: 'New company name',
        splitHint: 'Creates a new company from this post and pins it.',
        unlock: 'Unpin',
        saved: 'Company saved.',
        merged: 'Companies merged.',
        splitDone: 'Post split off.',
        unlocked: 'Post unpinned.',
        resolved: 'Matching finished.',
        actionFailed: 'Action failed.',
        statsKpisTitle: 'Overview',
        kpiCompanies: 'Companies',
        kpiRepeat: 'Repeat victims',
        kpiMultiGroup: 'Multiple groups',
        kpiMaxHits: 'Most hits',
        statsBuckets: 'Hits per company',
        statsTopGroups: 'Top groups (repeat victims)',
        statsNoData: 'No data',
        statsLoadFailed: 'Stats could not be loaded.',
      },
    },
  },
  de: {
    hackwatch: {
      posts: {
        title: 'Hack Posts',
        filtersTitle: 'Filter',
        filterReset: 'Filter zurücksetzen',
        filterCountryLabel: 'Land',
        filterCountryPlaceholder: 'Alle Länder…',
        filterCountriesSelected: '{0} Länder',
        filterIndustryLabel: 'Branche',
        filterIndustryPlaceholder: 'Alle Branchen…',
        filterIndustriesSelected: '{0} Branchen',
        filterGroupLabel: 'Hacker-Gruppe',
        filterGroupPlaceholder: 'Alle Gruppen',
        filterDateLabel: 'Zeitraum',
        filterDatePlaceholder: 'Start – Ende',
        filterSearchPlaceholder: 'Suchen…',
        filtersActive: '{0} Filter aktiv',
        colTitle: 'Titel',
        colGroup: 'Gruppe',
        colCountry: 'Land',
        colDomain: 'Domain',
        colIndustry: 'Branche',
        colAttackDate: 'Angriff',
        colDiscovered: 'Entdeckt',
        untitled: 'Ohne Titel',
        loadFailed: 'Posts konnten nicht geladen werden.',
        // stats panel
        statsDays7:            'Letzte 7 Tage',
        statsDays30:           'Letzte 30 Tage',
        statsDays90:           'Letzte 90 Tage',
        statsDays365:          'Letztes Jahr',
        statsGroups:           'Top Gruppen',
        statsCountries:        'Top Länder',
        statsIndustries:       'Top Branchen',
        statsRecent:           'Zuletzt entdeckt',
        statsOther:            'Sonstige',
        statsUnknown:          'Unbekannt',
        statsLoadFailed:       'Statistiken konnten nicht geladen werden.',
        chipGroup:             'Gruppe',
        chipCountry:           'Land',
        chipIndustry:          'Branche',
      },

      postDetail: {
        pageTitle: 'Hackwatch – Post {id}',
        editBtn: 'Bearbeiten',
        doneBtn: 'Fertig',
        backBtn: 'Zurück',
        noTitle: 'Ohne Titel',
        unknownGroup: 'Unbekannte Gruppe',
        discovered: 'Entdeckt',
        created: 'Erstellt',
        updated: 'Aktualisiert',
        domain: 'Domain',
        attack: 'Attacke',
        publicPage: 'Öffentliche Seite',
        claimLeak: 'Claim/Leak',
        extraInfos: 'Zusatzinformationen',
        screenshot: 'Screenshot',
        noScreenshot: 'Kein Screenshot vorhanden.',
        companyData: 'Unternehmensdaten',
        companyName: 'Unternehmen',
        address: 'Adresse',
        register: 'Register',
        vatId: 'USt-ID',
        management: 'Geschäftsführung',
        contact: 'Kontakt',
        industry: 'Branche',
        websiteLang: 'Website-Sprache',
        whois: 'WHOIS',
        openCorporates: 'OpenCorporates',
        viewEntry: 'Eintrag ansehen',
        impressum: 'Impressum',
        lastEnriched: 'Zuletzt angereichert',
        editDetails: 'Details bearbeiten',
        fieldSelectPlaceholder: 'Feld auswählen…',
        valuePlaceholder: 'Wert eingeben…',
        addBtn: 'Hinzufügen',
        allDetails: 'Alle Details',
        noDetails: 'Keine Details vorhanden.',
        settingName: 'Setting',
        value: 'Value',
        captured: 'Erfasst',
        loadFailed: 'Laden fehlgeschlagen.',
        settingsLoadFailed: 'Settings konnten nicht geladen werden.',
        saved: 'Gespeichert',
        added: 'Hinzugefügt',
        deleted: 'Gelöscht',
        saveFailed: 'Speichern fehlgeschlagen.',
        addFailed: 'Hinzufügen fehlgeschlagen.',
        deleteFailed: 'Löschen fehlgeschlagen.',
        confirmDelete: '"{name}" wirklich löschen?',
        detailUpdated: '{name} aktualisiert.',
        detailRemoved: '{name} entfernt.',
        detailSaved: '{name} gespeichert.',
        released: 'Freigegeben',
        releaseFailed: 'Freigabe fehlgeschlagen.',
        detailReleased: '{name} für automatische Updates freigegeben.',
        manualLockHint: 'Manuell bearbeitet — vor automatischem Überschreiben durch den Updater geschützt.',
        releaseHint: 'Für automatische Updates freigeben (der Updater darf diesen Wert wieder überschreiben).',
        foundedPrefix: 'Gegr.',
        infostealer: 'Infostealer Intelligence',
        isEmployees: 'Kompromittierte Mitarbeiter',
        isUsers: 'Kompromittierte Nutzer',
        isThirdParties: 'Drittanbieter',
        isEmployeesUrl: 'Mitarbeiter-URLs',
        isUsersUrl: 'Nutzer-URLs',
        isLastEmployee: 'Letzter Mitarbeiter-Kompromiss',
        isLastUser: 'Letzter Nutzer-Kompromiss',
        isStealers: 'Erkannte Stealer',
        isUpdated: 'Datenstand',
      },

      groups: {
        title: 'Hacker-Gruppen',
        addBtn: 'Gruppe hinzufügen',
        editTooltip: 'Bearbeiten',
        deleteTooltip: 'Löschen',
        colId: 'ID',
        colName: 'Name',
        colDescription: 'Beschreibung',
        colCreated: 'Erstellt',
        colUpdated: 'Letztes Update',
        colVictims: 'Opfer',
        colCountry: 'Land',
        colTtps: 'TTPs',
        colTools: 'Tools',
        colFirstSeen: 'Erstmals gesehen',
        colStateSponsor: 'Staatl. Sponsor',
        filterRaasLabel: 'RaaS',
        filterRaasAll: 'Alle',
        filterRaasOnly: 'Nur RaaS',
        filterRaasNone: 'Kein RaaS',
        badgeRaas: 'RaaS',
        filterCountryLabel: 'Land',
        filterCountryPlaceholder: 'Alle Länder',
        filterCountrySearch: 'Land suchen…',
        filterStateSponsorLabel: 'Staatl. Sponsor',
        filterStateSponsorPlaceholder: 'Alle Sponsoren',
        filterStateSponsorAny: 'Mit Sponsor',
        filterStateSponsorNone: 'Ohne Sponsor',
        filterHasTtps: 'Verknüpfte TTPs',
        filterHasTools: 'Verknüpfte Tools',
        filterHasTtpsYes: 'Mit TTPs',
        filterHasTtpsNo: 'Ohne TTPs',
        filterHasToolsYes: 'Mit Tools',
        filterHasToolsNo: 'Ohne Tools',
        filterAny: 'Beliebig',
        filterReset: 'Filter zurücksetzen',
        filtersTitle: 'Filter',
        sortByLabel: 'Sortieren nach',
        dialogCreate: 'Gruppe hinzufügen',
        dialogEdit: 'Gruppe bearbeiten',
        formName: 'Name',
        formNamePlaceholder: 'z.B. LockBit',
        formDescription: 'Beschreibung',
        formDescriptionPlaceholder: 'Kurzbeschreibung (optional)',
        nameMissing: 'Bitte einen Namen angeben.',
        saved: 'Gespeichert',
        groupCreated: 'Gruppe wurde erstellt.',
        groupUpdated: 'Gruppe wurde aktualisiert.',
        deleted: 'Gelöscht',
        groupDeleted: 'Gruppe wurde entfernt.',
        saveFailed: 'Speichern fehlgeschlagen.',
        deleteFailed: 'Löschen fehlgeschlagen.',
        loadFailed: 'Gruppen konnten nicht geladen werden.',
        confirmDelete: 'Möchtest du diese Gruppe wirklich löschen?',
        statsActivity: 'Aktivität',
        statsActive: 'Aktiv',
        statsInactive: 'Inaktiv',
        statsRecent: 'Zuletzt hinzugefügt',
        statsCountries: 'Länder',
        statsTtps: 'Top TTPs',
        statsTools: 'Top Tools',
        statsYears: 'First Seen pro Jahr',
        statsOther: 'Andere',
        statsUnknown: 'Unbekannt',
        statsLoadFailed: 'Gruppen-Statistiken konnten nicht geladen werden.',
        statsDays7: '7 Tage',
        statsDays30: '30 Tage',
        statsDays90: '90 Tage',
        statsDays365: '1 Jahr',
        chipActivity: 'Aktivität',
        chipTtp: 'TTP',
        chipTool: 'Tool',
        chipFirstSeen: 'First Seen',
      },

      groupDetail: {
        pageTitle: 'Hacker Group – Details',
        legendOverview: 'Hacker Group',
        legendKpis: 'Summary / KPIs',
        legendAliases: 'Aliases / Bekannte Namen',
        legendProfiles: 'Informationsquellen',
        legendLocations: 'Locations / Onion-Sites',
        legendTtps: 'MITRE ATT&CK TTPs',
        legendPosts: 'Hack Posts',
        legendTools: 'Tools',
        legendCoverage: 'SIEM Workflow Coverage',
        labelName: 'Name',
        labelDescription: 'Beschreibung',
        labelCountry: 'Land',
        labelStateSponsor: 'Staatl. Sponsor',
        labelAttributionConfidence: 'Attribution',
        labelRaas: 'RaaS',
        labelVictimCount: 'Opfer',
        labelFirstSeen: 'Erstmals gesehen',
        labelUrl: 'URL',
        labelMotive: 'Motiv',
        labelTargetedSectors: 'Zielbranchen',
        labelFamilies: 'Malware-Familien',
        labelMitreGroup: 'MITRE ATT&CK',
        labelMalpedia: 'Malpedia',
        labelCreated: 'Erstellt',
        labelUpdated: 'Aktualisiert',
        overviewLoading: 'Lade Gruppendetails…',
        overviewNotFound: 'Keine Gruppendetails gefunden.',
        overviewError: 'Fehler beim Laden der Gruppendetails.',
        kpisLoading: 'Lade KPIs…',
        kpisError: 'Summary konnte nicht geladen werden.',
        profilesLoading: 'Lade Quellen…',
        profilesEmpty: 'Keine Informationsquellen vorhanden.',
        profilesError: 'Fehler beim Laden der Informationsquellen.',
        profileColUrl: 'URL',
        profileColAdded: 'Hinzugefügt',
        profileAdd: 'Quelle hinzufügen',
        profileAddDialogTitle: 'Neue Informationsquelle',
        profileUrlLabel: 'URL',
        profileUrlPlaceholder: 'https://…',
        profileAdded: 'Quelle hinzugefügt.',
        profileAddFailed: 'Hinzufügen fehlgeschlagen.',
        profileDeleted: 'Quelle entfernt.',
        profileDeleteFailed: 'Löschen fehlgeschlagen.',
        profileDeleteConfirm: 'Diese Informationsquelle wirklich entfernen?',
        profileDuplicate: 'Diese URL ist für diese Gruppe bereits gespeichert.',
        locationsEmpty: 'Keine Locations vorhanden.',
        locationsError: 'Locations konnten nicht geladen werden.',
        locColStatus: 'Status',
        locColUrl: 'URL',
        locColTitle: 'Titel',
        locColLastScrape: 'Letzter Scan',
        locStatusOnline: 'Online',
        locStatusOffline: 'Offline',
        locStatusUnknown: 'Noch nicht gescannt',
        locShowOffline: 'Offline anzeigen ({count})',
        locHideOffline: 'Offline ausblenden',
        locAdd: 'Location hinzufügen',
        locAddDialogTitle: 'Neue Location',
        locFqdnLabel: 'URL / Domain',
        locFqdnPlaceholder: 'http://….onion oder https://…',
        locTitleLabel: 'Titel (optional)',
        locTitlePlaceholder: 'Kurze Beschreibung…',
        locAdded: 'Location hinzugefügt.',
        locAddFailed: 'Hinzufügen fehlgeschlagen.',
        locDeleted: 'Location entfernt.',
        locDeleteFailed: 'Löschen fehlgeschlagen.',
        locDeleteConfirm: 'Diese Location wirklich entfernen?',
        locDuplicate: 'Diese URL ist für diese Gruppe bereits gespeichert.',
        addAlias: 'Hinzufügen',
        newAliasPlaceholder: 'Neuer Alias…',
        aliasName: 'Alias',
        aliasTime: 'Zeitpunkt',
        noAliases: 'Keine Aliases vorhanden.',
        aliasLoadFailed: 'Aliases konnten nicht geladen werden.',
        offlineLocations: 'Offline ({count})',
        noWorkflowLinked: 'Kein Workflow',
        coveredOnly: 'Nur abgedeckte TTPs',
        allTtps: 'Alle TTPs',
        covered: 'abgedeckt',
        gaps: 'Lücken',
        workflows: 'Workflows',
        noTtps: 'Keine TTPs gefunden.',
        noPosts: 'Keine Posts vorhanden.',
      },

      ttps: {
        title: 'TTPs',
        tabMatrix: 'Matrix',
        tabTactics: 'Taktiken',
        tabTechniques: 'Techniken',
        matrixHint: 'Klicke auf eine Technik, um die Detailseite zu öffnen.',
        matrixOther: 'Sonstige / Unkategorisiert',
        matrixSelectTactic: 'Wähle links eine Taktik, um ihre Techniken anzuzeigen.',
        tacticTechniques: 'Techniken',
        filtersTitle: 'Filter',
        filterReset: 'Filter zurücksetzen',
        tacticLabel: 'Taktik',
        tacticPlaceholder: 'Alle Taktiken',
        allTactics: 'Alle Taktiken',
        detectionsLabel: 'Detections',
        detectionsAll: 'Alle',
        detectionsYes: 'Mit Detections',
        detectionsNone: 'Ohne Detections',
        onlyWithDetections: 'Nur mit Detections',
        colTechnique: 'Technik',
        colTactic: 'Taktik',
        colDescription: 'Beschreibung',
        colUpdated: 'Aktualisiert',
        colMitre: 'MITRE',
        colConfidence: 'Confidence',
        colLinkedAt: 'Verknüpft',
        viewDetails: 'Details',
        noTtps: 'Keine TTPs vorhanden.',
        loadFailed: 'TTPs konnten nicht geladen werden.',
      },

      // ── MITRE ATT&CK Coverage (Redesign /threat-intel/mitre) ──────────────
      mitre: {
        title: 'MITRE ATT&CK',
        subtitle: 'Detection-Coverage über die ATT&CK-Matrix',
        modeMatrix: 'Matrix',
        modeCards: 'Karten',
        kpiTechniques: 'Techniken',
        kpiCovered: 'Abgedeckt',
        kpiGaps: 'Lücken',
        kpiCoverage: 'Coverage',
        coverageLegend: 'Coverage',
        legendGap: 'Keine Abdeckung',
        legendLow: 'Gering',
        legendMed: 'Mittel',
        legendHigh: 'Hoch',
        tacticsLabel: 'Taktiken',
        allTactics: 'Alle Taktiken',
        techniquesCount: 'Techniken',
        noTechniques: 'Keine Techniken in dieser Taktik.',
        statGroups: 'Gruppen',
        statGroupsTip: 'Bedrohungsgruppen, die diese Technik nutzen (CTI)',
        statWorkflows: 'Workflows',
        statWorkflowsTip: 'SIEM-Workflows, die diese Technik abdecken (für dich sichtbar)',
        gapBadge: 'Lücke',
        coveredBadge: 'Abgedeckt',
        selectHint: 'Wähle eine Technik, um Details, Coverage und letzte Plattform-Ereignisse zu sehen.',
        detailDescription: 'Beschreibung',
        detailTactics: 'Taktiken',
        detailGroups: 'Bedrohungsgruppen, die diese Technik nutzen',
        detailWorkflows: 'Workflows, die diese Technik abdecken',
        detailEvents: 'Letzte Plattform-Ereignisse',
        eventsHeuristicHint: 'Heuristischer Abgleich über den Workflow-Namen — nur Partner-Kunden.',
        noGroups: 'Keine Bedrohungsgruppen verknüpft.',
        noWorkflows: 'Keine für dich sichtbaren abdeckenden Workflows.',
        noEvents: 'Keine passenden Plattform-Ereignisse.',
        noDescription: 'Keine Beschreibung verfügbar.',
        subtechnique: 'Sub-Technik',
        colGroup: 'Gruppe',
        colConfidence: 'Confidence',
        colSource: 'Quelle',
        colWorkflow: 'Workflow',
        colSeverity: 'Severity',
        colCustomer: 'Kunde',
        colEvent: 'Ereignis',
        colWhen: 'Wann',
        loadFailed: 'MITRE-Matrix konnte nicht geladen werden.',
        closeDetail: 'Schließen',
        openLegacy: 'Vollseite öffnen',
      },

      ttpDetail: {
        backBtn: 'Zurück',
        legendDescription: 'Beschreibung',
        legendDetections: 'Detections',
        legendMitigations: 'Mitigations',
        legendMeta: 'Meta',
        legendReferences: 'References',
        legendGroups: 'Hacker Groups die diese TTP verwenden',
        legendWorkflows: 'SIEM Workflows die diese TTP abdecken',
        noMitreId: 'Kein MITRE-ID gesetzt — Workflow-Matching nicht möglich.',
        noGroupsLinked: 'Keine Gruppen verknüpft.',
        noWorkflows: 'Keine SIEM Workflows gefunden, die diese Technik abdecken.',
        createdAt: 'Erstellt',
        updatedAt: 'Aktualisiert',
        version: 'Version',
        colGroup: 'Gruppe',
        colWorkflow: 'Workflow',
        colSeverity: 'Severity',
        colConfidence: 'Confidence',
        colRationale: 'Rationale',
        colSource: 'Quelle',
        colLinkedAt: 'Verknüpft',
        loadFailed: 'Laden fehlgeschlagen.',
      },

      tools: {
        title: 'Tools (Ranked)',
        colRank: 'Rank',
        colTool: 'Tool',
        colCategory: 'Kategorie',
        colLinks: 'Links',
        colLastLink: 'Last Link',
        categoryPlaceholder: 'Kategorie',
        noTools: 'Keine Tools vorhanden.',
        loadFailed: 'Tools konnten nicht geladen werden.',
      },

      extension: {
        title: 'Extensions',
        colId: 'ID',
        colExtension: 'Extension',
        colGroup: 'Hacker Group',
        addBtn: 'Extension hinzufügen',
        editTooltip: 'Bearbeiten',
        deleteTooltip: 'Löschen',
        dialogCreate: 'Extension hinzufügen',
        dialogEdit: 'Extension bearbeiten',
        formExtension: 'Extension',
        formGroup: 'Hacker Group',
        formGroupPlaceholder: 'Bitte wählen',
        nameMissing: 'Bitte einen Extension-Namen angeben.',
        groupMissing: 'Bitte eine Hacker-Gruppe auswählen.',
        groupsLoadFailed: 'Hacker-Gruppen konnten nicht geladen werden.',
        loadFailed: 'Extensions konnten nicht geladen werden.',
        saved: 'Gespeichert',
        extensionCreated: 'Extension wurde erstellt.',
        extensionUpdated: 'Extension wurde aktualisiert.',
        deleted: 'Gelöscht',
        extensionDeleted: 'Extension wurde entfernt.',
        saveFailed: 'Speichern fehlgeschlagen.',
        deleteFailed: 'Löschen fehlgeschlagen.',
        invalidId: 'Keine gültige ID gefunden.',
        confirmDelete: 'Extension wirklich löschen?',
      },

      postsByGroup: {
        title: 'Hack Posts',
        colTitle: 'Titel',
        colCountry: 'Land',
        colDomain: 'Domain',
        colDiscovered: 'Entdeckt',
        noPosts: 'Keine Posts vorhanden.',
        loadFailed: 'Posts konnten nicht geladen werden.',
      },

      groupsOverview: {
        colGroup: 'Gruppe',
        colMembers: 'Members',
        colLocations: 'Locations',
        colProfiles: 'Profiles',
        colToolsLinks: 'Tools Links',
        colTtpLinks: 'TTP Links',
        loadFailed: 'Übersicht konnte nicht geladen werden.',
      },

      groupHistory: {
        title: 'Hacker Group History',
        loading: 'Lade History…',
        error: 'Fehler beim Laden der History.',
        currentName: 'Aktueller Name',
        recentChanges: 'Letzte Namensänderungen',
        changedAt: 'Am {date} geändert zu {name}',
        noHistory: 'Keine History vorhanden.',
      },

      // ── IOCs ─────────────────────────────────────────────────────────────
      iocs: {
        pageTitle: 'IOCs – Indicators of Compromise',
        legendTitle: 'IOCs',
        filtersTitle: 'Filter',
        filterReset: 'Filter zurücksetzen',
        filterTypeLabel: 'Typ',
        filterTypeAll: 'Alle Typen',
        filterGroupLabel: 'Hacker-Gruppe',
        filterGroupPlaceholder: 'Alle Gruppen',
        filterDateLabel: 'Erstellt (Zeitraum)',
        filterDatePlaceholder: 'Start – Ende',
        addBtn: 'IOC hinzufügen',
        deleteAllBtn: 'Alle IOCs löschen',
        confirmDeleteAll: 'Wirklich ALLE IOCs dieser Gruppe löschen?',
        colType: 'Typ',
        colValue: 'Wert',
        colNote: 'Notiz',
        colCreated: 'Erstellt',
        colGroup: 'Gruppe',
        filterTypePlaceholder: 'IOC-Typ',
        dialogCreate: 'IOC hinzufügen',
        dialogEdit: 'IOC bearbeiten',
        formType: 'Typ',
        formTypePlaceholder: 'z.B. ip, domain, md5',
        formValue: 'Wert',
        formValuePlaceholder: 'IOC-Wert',
        formSource: 'Quelle',
        formNote: 'Notiz (optional)',
        typeMissing: 'Bitte einen Typ angeben.',
        valueMissing: 'Bitte einen Wert angeben.',
        saved: 'Gespeichert',
        iocCreated: 'IOC wurde hinzugefügt.',
        iocUpdated: 'IOC wurde aktualisiert.',
        deleted: 'Gelöscht',
        iocDeleted: 'IOC wurde entfernt.',
        allDeleted: 'Alle IOCs wurden entfernt.',
        saveFailed: 'Speichern fehlgeschlagen.',
        deleteFailed: 'Löschen fehlgeschlagen.',
        loadFailed: 'IOCs konnten nicht geladen werden.',
        noIOCs: 'Keine IOCs vorhanden.',
        typeSummary: 'Typ-Übersicht',
        editTooltip: 'Bearbeiten',
        deleteTooltip: 'Löschen',
        detailTitle: 'IOC Details',
        detailSource: 'Quelle',
        colThreatType: 'Bedrohungstyp',
        colConfidence: 'Konfidenz',
        colReporter: 'Reporter',
        colFirstSeen: 'Erstmals gesehen',
        colTags: 'Tags',
        filterSource: 'Quelle',
        filterSourceAll: 'Alle Quellen',
        filterSourcePlaceholder: 'Quelle',
        filterThreatTypeLabel: 'Bedrohungstyp',
        filterThreatTypePlaceholder: 'Alle Bedrohungstypen',
        filterConfidenceLabel: 'Konfidenz',
        filterConfidencePlaceholder: 'Alle Stufen',
        confidenceHigh: 'Hoch (≥75%)',
        confidenceMedium: 'Mittel (40–74%)',
        confidenceLow: 'Niedrig (<40%)',
        // stats panel
        statsGroups:      'Top Gruppen',
        statsTypes:       'IOC-Typen',
        statsThreatTypes: 'Bedrohungstypen',
        statsConfidence:  'Konfidenz',
        statsOther:       'Sonstige',
        statsLoadFailed:  'Statistiken konnten nicht geladen werden.',
      },
      victims: {
        title: 'Betroffene Unternehmen',
        subtitle: 'Firmen, die mit Ransomware-Leak-Posts verknüpft sind.',
        filtersTitle: 'Filter',
        filterReset: 'Zurücksetzen',
        search: 'Firma oder Domain suchen',
        filterCountryLabel: 'Land',
        filterCountryPlaceholder: 'Alle Länder…',
        filterCountriesSelected: '{0} Länder',
        filterIndustryLabel: 'Branche',
        filterIndustryPlaceholder: 'Alle Branchen…',
        filterIndustriesSelected: '{0} Branchen',
        filterGroupLabel: 'Gruppe',
        filterGroupPlaceholder: 'Alle Gruppen…',
        repeatOnly: 'Nur Wiederholungen (>1 Post)',
        multiGroupOnly: 'Nur mehrere Gruppen',
        resolve: 'Zuordnung neu berechnen',
        resolveHint: 'Posts den Firmen neu zuordnen (läuft auch in jedem Updater-Zyklus).',
        colCompany: 'Firma',
        colDomain: 'Domain',
        colCountry: 'Land',
        colIndustry: 'Branche',
        colCount: 'Posts',
        colGroups: 'Gruppen',
        colFirst: 'Erster Treffer',
        colLast: 'Letzter Treffer',
        manual: 'Kuratiert',
        manualHint: 'Enthält manuell kuratierte Felder.',
        noVictims: 'Keine Firmen gefunden.',
        loadFailed: 'Betroffene Unternehmen konnten nicht geladen werden.',
        detailTitle: 'Firmen-Details',
        pageTitle: 'Betroffenes Unternehmen',
        overviewTitle: 'Stammdaten',
        profileTitle: 'Firmenprofil',
        profileEmpty: 'Noch keine Firmendaten — füllt sich automatisch, sobald Posts angereichert werden.',
        fieldEmployees: 'Mitarbeiter',
        fieldFounded: 'Gegründet',
        fieldLegalForm: 'Rechtsform',
        fieldCity: 'Stadt',
        fieldAddress: 'Adresse',
        sourceManual: 'Manuell',
        sourceManualHint: 'Manuell gesetzt — vor automatischen Updates geschützt.',
        sourceAuto: 'Aus Posts',
        sourceAutoHint: 'Automatisch aus verknüpften Posts befüllt.',
        postsTitle: 'Verknüpfte Hack-Posts',
        noPosts: 'Keine Posts verknüpft.',
        colPostTitle: 'Post-Titel',
        colGroup: 'Gruppe',
        colDiscovered: 'Entdeckt',
        colActions: 'Aktionen',
        openPost: 'Post öffnen',
        locked: 'Gepinnt',
        lockedHint: 'Manuell an diese Firma gepinnt.',
        edit: 'Bearbeiten',
        editTitle: 'Firma bearbeiten',
        fieldName: 'Anzeigename',
        fieldDomain: 'Haupt-Domain',
        fieldCountry: 'Land',
        fieldIndustry: 'Geschäftsfeld',
        fieldNotes: 'Notizen',
        merge: 'Firma zusammenführen',
        mergeTitle: 'Andere Firma in diese zusammenführen',
        mergePlaceholder: 'Firma zum Zusammenführen suchen…',
        mergeHint: 'Die Posts der gewählten Firma wandern hierher; sie wird zum Alias.',
        split: 'Abspalten',
        splitTitle: 'Post in neue Firma abspalten',
        splitNewName: 'Name der neuen Firma',
        splitHint: 'Erstellt aus diesem Post eine neue Firma und pinnt ihn.',
        unlock: 'Lösen',
        saved: 'Firma gespeichert.',
        merged: 'Firmen zusammengeführt.',
        splitDone: 'Post abgespalten.',
        unlocked: 'Post gelöst.',
        resolved: 'Zuordnung abgeschlossen.',
        actionFailed: 'Aktion fehlgeschlagen.',
        statsKpisTitle: 'Überblick',
        kpiCompanies: 'Firmen',
        kpiRepeat: 'Wiederholungs-Opfer',
        kpiMultiGroup: 'Mehrere Gruppen',
        kpiMaxHits: 'Meiste Treffer',
        statsBuckets: 'Treffer pro Firma',
        statsTopGroups: 'Top-Gruppen (Wiederholungs-Opfer)',
        statsNoData: 'Keine Daten',
        statsLoadFailed: 'Statistiken konnten nicht geladen werden.',
      },
    },
  },
}
